<template>
    <div >
        <textarea :id="id"></textarea>
    </div>
</template>

<script>
    import CKEDITOR from "CKEDITOR"
    export default {
        name: 'ckeditors',
        props: [
            'value',"parameter","width","height"
        ],
        mounted: function () {
            const self = this
            // 渲染编辑器
            // self.ckeditor = window.CKEDITOR.replace(self.id)
            // CKEditor 配置项
            let ckConfig = {
                toolbarGroups: [
                    { name: 'clipboard',   groups: [ 'clipboard', 'undo' ] },
                    { name: 'editing',     groups: [ 'find', 'selection', 'spellchecker' ] },
                    { name: 'links' },
                    { name: 'insert' },
                    { name: 'forms' },
                    { name: 'tools' },
                    { name: 'document',	   groups: [ 'mode', 'document', 'doctools' ] },
                    { name: 'others' },
                    '/',
                    { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                    { name: 'paragraph',   groups: [ 'list', 'indent', 'blocks', 'align', 'bidi' ] },
                    { name: 'styles' },
                    { name: 'colors' },
                    { name: 'about' }
                ],
                fileTools_requestHeaders: {
                    "Authorization": window.sessionStorage.getItem('signature')
                },
                filebrowserImageUploadUrl: this.parameter == 1
                    ? this.$store.state.emailEditorUpload
                    : this.$store.state.ckeditorsUrl,
                filebrowserUploadUrl: this.$store.state.ckeditorsUrl,
                // filebrowserImageUploadUrl: 'http://192.168.1.179/demo_vue/public/home/demo/editorUpload',
                filebrowserUploadMethod: 'xhr',
                image_previewText: '',
                disallowedContent: 'img{width,height,float}',
                extraAllowedContent: 'img[width,height,align];span{background}',
                allowedContent:true,
                // extraPlugins : 'wordcount',
                // wordcount: {
                //     countHTML: true,
                //     // Whether or not you want to show the Word Count
                //     showWordCount: false,
                //     // Whether or not you want to show the Char Count
                //     showCharCount: true,
                //     // Maximum allowed Word Count
                //     maxWordCount: 0,
                //     // Maximum allowed Char Count
                //     maxCharCount: 10000
                // }
            }
            self.width ? ckConfig.width = self.width : '';
            self.height ? ckConfig.height = self.height : ckConfig.height = 400;
            self.ckeditor = CKEDITOR.replace(self.id, ckConfig)
            // 监听内容变更事件
            self.ckeditor.on('change', function () {
                // self.$emit("changCkNum", self.ckeditor.getData().length);
                self.$emit("changCkNums", self.ckeditor.getData().length);
                // setTimeout(() => {
                //     self.$emit('input', self.ckeditor.getData())
                // },500)
            })
            self.ckeditor.on('instanceReady', function (e) {
                self.typea=true
                self.$emit("instanceReadyCk",self.typea );
            });
            this.$on('getText', function() {
                self.$emit('input', self.ckeditor.getData())
            });
        },
        data: function () {
            return {
                values: "",
                id: parseInt(Math.random() * 10000).toString(),
                ckeditor: null,
                types:1,
                typea:null
            }
        },
        watch: {
            // 监听prop的变化，更新ckeditor中的值
            value: function () {
                let self=this
                self.ckeditor.setData(self.value)
            },
        },
        methods:{
            // getText(){
            //     self.$emit('input', self.ckeditor.getData())
            // }
        },
        // 销毁组件前，销毁编辑器
        beforeDestroy() {
            this.ckeditor.destroy()
            // self.ckeditor.instances.editor1.destroy();
        }
    }
</script>
